// Lib
import { shouldUpdate, shallowEqual } from 'recompose';
import { omit } from 'lodash';

// Helper
import createHelper from './createHelper';

const dontUpdateForKeys = (propKeys) =>
    shouldUpdate((props, nextProps) => !shallowEqual(omit(nextProps, propKeys), omit(props, propKeys)));

export default createHelper(dontUpdateForKeys, 'dontUpdateForKeys');
